export default {
    FPDualEntryComputer: {
        datapoint: {
            name: 'FPDualEntryComputer',
            customData: (entrySource: string) => ({ entrySource: entrySource }),
        },
    },
    FPDualEntryFilePicker: {
        datapoint: {
            name: 'FPDualEntryFilePicker',
            customData: (entrySource: string) => ({ entrySource: entrySource }),
        },
    },
    FPMultiEntryUploadAndShareFromCloud: {
        datapoint: {
            name: 'FPMultiEntryUploadAndShareFromCloud',
            customData: (entrySource: string) => ({ entrySource: entrySource }),
        },
    },
};
